import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import enUS from "locale/en_US"
import zhCN from "locale/zh_CN"

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: enUS
  },
  zh: {
    translation: zhCN
  }
};

const lng = localStorage.getItem('Language');


i18n
  .use(LanguageDetector) // 嗅探当前浏览器语言
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: lng ? lng : "zh",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  }).then();

export default i18n;
